import { createContext } from 'react'

import { GetProfileResponse } from '@cash-web/protos/squareup/franklin/app/profile.pb'
import { Profile } from '@cash-web/protos/squareup/franklin/ProfileProto.pb'
import { HttpError } from '@cash-web/shared-util-fetch'

export type AuthContextInterface = {
  /**
   * @deprecated Read fields via the granular `useProfile*` hooks in data-access-core-profile.
   * See data-access-core-profile/README.md for more information.
   */
  profile?: Profile
  isLoading: boolean
  isFetching: boolean
  error?: HttpError<GetProfileResponse> | null
}

export const AuthContext = createContext<AuthContextInterface | undefined>(undefined)
